module.exports = __webpack_public_path__ + "img/lowAltitude3.59636c35.jpg";